import { PAYMENT_LINE_ITEM_TYPES } from 'Common/Constants';
import CustomInput from 'Common/CustomInput/CustomInput';
import CustomLabel from 'Common/CustomLabel/CustomLabel';
import CustomSelect from 'Common/CustomSelect';
import Show from 'Components/Show/Show';
import React from 'react'
import { LuTrash2, LuPlus, LuCircleAlert } from "react-icons/lu";
import NumberConversion from './../../../Utils/NumberConversion';
import CustomTextarea from 'Common/CustomTextArea';
import { Tooltip } from 'react-tooltip';
const PaymentLineItems = ({ lineItems, updateLineItem, removeLineItem, addLineItem, lineItemsValidationModel, patientDetail }) => {
    const outBalanceLineItem = lineItems.find((item) => item.itemType === 'OUTBAL');
    const outBalanceLineItemIndex = lineItems.findIndex((item) => item.itemType === 'OUTBAL');
    return (
        <div>
            <Tooltip id="PaymentLineItems-tooltip" style={{ zIndex: 2, maxWidth: 220 }} />
            <label className="block mb-2 text-sm font-medium text-slate-700">Line Items</label>
            <div className="space-y-2 ">
                {lineItems.map((item, index) => {
                    // Get all item types that are already selected in other line items
                    const selectedItemTypes = lineItems
                        .filter((otherItem) => otherItem.identifier !== item.identifier && otherItem.itemType)
                        .map((otherItem) => otherItem.itemType);

                    // Filter out already selected types, but keep the current item's type
                    const availableTypes = PAYMENT_LINE_ITEM_TYPES.filter((type) =>
                        type.showInDropdown &&
                        (!selectedItemTypes.includes(type.value) || type.value === item.itemType)
                    );

                    return (
                        <div key={item.identifier}>
                            <div className={`flex items-center gap-3 ${lineItemsValidationModel[index].amountError || item.itemType === 'COP' ? 'mb-6' : 'mb-0'}`}>
                                <div className="space-y-2 ">
                                    <CustomSelect
                                        value={item.itemType}
                                        onChange={(e) => updateLineItem(item.identifier, 'itemType', e.target.value)}
                                        wrapperClass="!w-72"
                                    >
                                        {
                                            availableTypes.map((type) => <option key={type.value} value={type.value}>{type.label} {type.value === 'OUTBAL' && `(${NumberConversion(patientDetail.balance)})`}</option>)
                                        }
                                    </CustomSelect>
                                    {lineItemsValidationModel[index].itemTypeError}
                                </div>
                                <div className="flex items-center flex-1 gap-2">
                                    <span className="text-slate-600">$</span>
                                    <div className="relative w-full " >
                                        <CustomInput isFloat isNumeric maxFloat={1} value={item.amount} onChange={(e) => updateLineItem(item.identifier, 'amount', (e.target.value))} step="0.01" />
                                        {/* <p className="absolute left-0 -bottom-6">{lineItemsValidationModel[index].amountError}</p> */}
                                    </div>
                                    <Show when={item.itemType === 'COP'}>
                                        <div className="relative w-full" >
                                            <CustomInput type="date" value={item.serviceDate || ''} onChange={(e) => updateLineItem(item.identifier, 'serviceDate', e.target.value)} placeholder="Date of Service" />
                                            <div className="absolute left-0 -bottom-6">{lineItemsValidationModel[index].serviceDateError ? lineItemsValidationModel[index].serviceDateError : <CustomLabel labelClass="block text-sm font-medium text-slate-700" label="Date of Service" required />}</div>
                                        </div>
                                    </Show>

                                    <Show when={item.itemType === 'DED' || item.itemType === 'COINS'}>
                                        <div className="relative w-full" >
                                            <CustomInput type="date" value={item.serviceDate || ''} onChange={(e) => updateLineItem(item.identifier, 'serviceDate', e.target.value)} placeholder="Date of Service" />
                                            <div className="absolute left-0 -bottom-6">{lineItemsValidationModel[index].serviceDateError ? lineItemsValidationModel[index].serviceDateError : <CustomLabel labelClass="block text-sm font-medium text-slate-700" label="Date of Service" />}</div>
                                        </div>
                                    </Show>

                                    <span className="text-sm text-slate-600">USD</span>
                                </div>
                                <Show when={item.identifier !== 0} fallback={<div className="p-4"></div>}>
                                    <button onClick={() => removeLineItem(item.identifier, index)} className="p-2 text-red-500 transition-colors rounded hover:bg-red-50"  >
                                        <LuTrash2 className="w-4 h-4" />
                                    </button>
                                </Show>
                            </div>
                            <Show when={item.itemType === 'OTHER'}>
                                <CustomTextarea data-tooltip-id="PaymentLineItems-tooltip"
                                    data-tooltip-content={'Maximum 100 characters'} maxWidth="100%" extraClass="mt-2" value={item.itemDescription || ''} onChange={(e) => updateLineItem(item.identifier, 'itemDescription', e.target.value)} placeholder="Enter reason for custom line item…" />
                                {lineItemsValidationModel[index].itemDescriptionError}
                            </Show>
                        </div>
                    );
                })}
            </div>

            {/* if all PAYMENT_LINE_ITEM_TYPES with showInDropdown are not selected then show the add line item button */}
            {(() => {
                const availableTypes = PAYMENT_LINE_ITEM_TYPES.filter((type) => type.showInDropdown && type.value !== "");
                const allTypesSelected = availableTypes.every((type) => lineItems.some((item) => item.itemType === type.value));
                return (
                    <Show when={!allTypesSelected}>
                        <button onClick={addLineItem} className="mt-2 flex items-center gap-1.5 text-sm text-blue-600 hover:text-blue-700" >
                            <LuPlus className="w-4 h-4" />
                            Add Line Item
                        </button>
                    </Show>
                );
            })()}
            {/* only show if patientDetail.balance > 0 and lineItems[0]?.amount < patientDetail.balance and lineItems[0]?.itemType === 'OUTBAL' */}
            <Show when={patientDetail.balance > 0 && outBalanceLineItem?.amount < patientDetail.balance}>
                <div className="p-4 my-4 border rounded-lg bg-amber-50 border-amber-200">
                    <div className="flex items-start gap-2 mb-2">
                        <LuCircleAlert className="w-4 h-4 text-amber-600 mt-0.5" />
                        <div className="flex-1">
                            <p className="text-sm font-medium text-amber-900">Partial Payment Detected</p>
                            <p className="mt-1 text-xs text-amber-700">
                                The payment amount ({NumberConversion(lineItems[0]?.amount)}) is less than the outstanding balance ({NumberConversion(patientDetail.balance)}). Please provide a reason for accepting a partial payment.
                            </p>
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 text-sm font-medium text-slate-700">
                            Override Note <span className="text-red-500 ">*</span>
                        </label>
                        <textarea
                            value={lineItems[outBalanceLineItemIndex]?.itemDescription || ''}
                            onChange={(e) => updateLineItem(lineItems[outBalanceLineItemIndex]?.identifier, 'itemDescription', e.target.value)}
                            placeholder="Example: Patient arranged payment plan for remaining balance with billing department on [date]. Partial payment of $X approved by [manager name]."
                            className="w-full px-3 py-2 text-sm border rounded-lg resize-none border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            rows={3}
                            required
                        />
                        <p className="mt-1 text-xs text-slate-500">
                            Suggested: Include payment arrangement details, approval date, and authorizing person.
                        </p>
                    </div>
                </div>
                <Show when={outBalanceLineItemIndex !== -1 && lineItemsValidationModel[outBalanceLineItemIndex]?.itemDescriptionError}>
                    <p style={{ marginTop: '0.25rem', fontSize: '0.875em' }} className="text-red-500 ">Override Note is required</p>
                </Show>

            </Show>

        </div>
    )
}

export default PaymentLineItems